<template>
    <v-app-bar dense fixed clipped-left app color="primary" dark>
        <v-toolbar-title class="mr-5 align-center font-weight-medium">
            <v-btn disabled icon class="pl-2">
                <v-img :src="image" max-height="2rem" max-width="2rem" class="mr-3" />
            </v-btn>
            <span> {{ adminOneTitle }} </span>
        </v-toolbar-title>
        <v-spacer />
        <v-toolbar-title class="omit-name mr-2">
            <span v-text="userName" />
        </v-toolbar-title>
        <div v-if="isShowButtons" class="profile-btn">
            <profile-button :profile-menu="menuList" @clickMenu="doMenuAction" />
        </div>
        <error-dialog
            v-if="showDialogEnable"
            ref="error-dialog"
            :title="'Application_Error'"
            :message="authErrorCode + ' - ' + authErrorMessage"
            @clickClose="closeDialog"
        />
    </v-app-bar>
</template>

<script setup lang="ts">
import { computed, getCurrentInstance, watch, ref, onMounted } from 'vue';
import { useTranslation } from '../../../composables/translation';
import { useRootStore } from '../../../store/composables';
import { useAuthStore } from '../../../store/modules/auth/composables';
import { useTheNodeSamlWorkListPageStore } from '../../../store/pages/node_saml/TheNodeSamlWorkListPageStore';
import { ProfileButton } from '../../molecules';
import AdminOneIMG from '../../../assets/image/adminone.png';
import { ErrorDialog } from '../../molecules';

/**
 * constant
 */
const image = AdminOneIMG;
const menuList = [
    {
        icon: 'fa-sign-out-alt',
        text: 'Logout',
        execute: (caller: any): void => {
            logout();
        },
    },
];

/**
 * properties
 */
interface Props {
    isShowButtons: boolean;
}
defineProps<Props>();

/**
 * composables
 */
const { t } = useTranslation();
const { embedded } = useRootStore();
const { uid, name, logout, isUpdated, dealUpdate } = useAuthStore();
const pageStore = useTheNodeSamlWorkListPageStore();
const authErrorStatus = ref<string>('');
const authErrorCode = ref<string>('');
const authErrorMessage = ref<string>('');
const showDialogEnable = ref<boolean>(false);

/**
 * setter, getters
 */
const adminOneTitle = computed(() => embedded.value.adminOneTitle);
const userName = computed(() => name.value || uid.value);

/**
 * methods
 */
function doMenuAction(callBackEvent: (caller: any) => void): void {
    if (window.confirm(t('To_display_this_screen_again,_you_must_connection_from_the_beginning'))) {
        callBackEvent(getCurrentInstance());
        pageStore.isLogout = true;
    }
}
function closeDialog(): void {
    showDialogEnable.value = false;
}

/**
 * watchers
 */
watch(
    isUpdated,
    () => {
        dealUpdate();
    },
    {
        immediate: true,
        deep: true,
    }
);

/**
 * lifecycle hooks
 */
onMounted(() => {
    const errorStatus = <HTMLInputElement | null>document.querySelector('input[name="auth-error-status"]');
    const errorCode = <HTMLInputElement | null>document.querySelector('input[name="auth-error-code"]');
    const errorMessage = <HTMLInputElement | null>document.querySelector('input[name="auth-error-message"]');
    if (errorStatus.value && errorStatus.value !== '500') {
        authErrorStatus.value = errorStatus.value;
        authErrorCode.value = errorCode.value;
        authErrorMessage.value = errorMessage.value;
        showDialogEnable.value = true;
    }
});
</script>

<style lang="scss" scoped>
.profile-btn {
    padding-top: 1rem;
}
.omit-name {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 30rem;
    font-size: 1rem;
}
</style>
